module.exports = __webpack_public_path__ + "img/ch14_13_深夜实验室布洛.403789e7.jpg";